const getters = {
  getContabilista: (state) => state.contabilista,
};

export default getters;
